const Person = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M17.7542 13.9992C18.9962 13.9992 20.003 15.0061 20.003 16.2481V17.1665C20.003 17.7399 19.8238 18.2989 19.4905 18.7654C17.9446 20.9287 15.4203 22.0004 12 22.0004C8.57903 22.0004 6.05607 20.9282 4.51391 18.7639C4.18195 18.298 4.00354 17.7401 4.00354 17.1681V16.2481C4.00354 15.0061 5.0104 13.9992 6.25242 13.9992H17.7542ZM12 2.00391C14.7614 2.00391 17 4.24248 17 7.00391C17 9.76533 14.7614 12.0039 12 12.0039C9.23857 12.0039 7 9.76533 7 7.00391C7 4.24248 9.23857 2.00391 12 2.00391Z"
      fill="currentColor"
    />
  </svg>
);

export default Person;
